import { AudioModelType, axiosInstance } from '../../utils';
import { UserAudio } from '../../@types';

export const getPublicAudios = async (model?: AudioModelType): Promise<UserAudio[]> => {
  const searchParams = new URLSearchParams();
  if(model) {
    searchParams.append('model', model);
  }
  const res = await axiosInstance.get(`/api/audios/get-public-voices?${searchParams.toString()}`);
  return res.data;
};
